<template>
<div id="transferManage">
  <div class="search">
    <div class="searchInline">
      <el-input v-model="searchParams.Name" placeholder="请输入名称活动" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-select v-model="searchParams.activityStatus" @change="submitSearch" placeholder="请选择活动状态" clearable>
        <el-option label="未开始" :value="0"></el-option>
        <el-option label="报名中" :value="1"></el-option>
        <el-option label="报名已满" :value="2"></el-option>
        <el-option label="报名结束" :value="3"></el-option>
        <el-option label="进行中" :value="4"></el-option>
        <el-option label="已结束" :value="5"></el-option>
        <el-option label="活动回顾" :value="6"></el-option>
      </el-select>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="submitSearch">搜索</el-button>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="searchClear()">清除</el-button>
    </div>
  </div>
  <div class="contentView">
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column
        prop="id"
        label="活动ID"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="activityName"
        label="活动名称"
        min-width="100">
      </el-table-column>
      <el-table-column label="报名时间" min-width="160">
        <template slot-scope="scope">
          <div>{{scope.row.enterStartDate}}</div>
          <div>{{scope.row.enterEndDate}}</div>
        </template>
      </el-table-column>
      <el-table-column label="活动时间" min-width="150">
        <template slot-scope="scope">
          <div>{{scope.row.activityStartDate}}</div>
          <div>{{scope.row.activityEndDate}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="limitPeople"
        label="参与限制"
        min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.limitPeople === 0">不限</span>
          <span v-if="scope.row.limitPeople !== 0">{{scope.row.limitPeople}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="takePartCount"
        label="参与数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        label="活动状态"
        min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.activityStatus == 0">未开始</span>
          <span v-if="scope.row.activityStatus == 1">报名中</span>
          <span v-if="scope.row.activityStatus == 2">报名已满</span>
          <span v-if="scope.row.activityStatus == 3">报名结束</span>
          <span v-if="scope.row.activityStatus == 4">进行中</span>
          <span v-if="scope.row.activityStatus == 5">已结束</span>
          <span v-if="scope.row.activityStatus == 6">往期回顾</span>
        </template>
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="copyUrl(scope.row)">复制URL</span>
        </template>
      </el-table-column>
    </el-table>
    <input type="text" id="inputValue" style="opacity: 0" value="" v-model="conment" name="">
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      searchParams: {
        mobile: '',
        Name: '',
        activityStatus: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 1
      },
      conment: '',
      tableData: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      dialog: {
        submit: {
          show: false,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      }
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList () {
      this.axios.get('/member/recommondActivityList' + devCode, {
        params: {
          batchId: this.$route.query.batchId,
          mobile: this.searchParams.mobile || this.$route.query.mobile,
          activityName: this.searchParams.Name,
          activityStatus: this.searchParams.activityStatus,
          releasedate: this.searchParams.time ? this.searchParams.time.join(',') : '',
          uploadReleasedate: this.searchParams.ffTime ? this.searchParams.ffTime.join(',') : '',
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        console.log(res);
        if (res.data.ok) {
          this.tableData = res.data.data.pageListData;
          this.totalResult = res.data.data.totalResult;
          this.totalPage = res.data.data.totalPage;
        };
      });
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 1;
      this.getList();
      this.currentPage = 1;
    },
    // 清除
    searchClear () {
      this.searchParams = {
        mobile: '',
        Name: '',
        activityStatus: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 1
      };
      this.getList();
    },
    // 更改pageSize
    sizeChange (val) {
      console.log(val, '22');
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 1;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      console.log(val, '11');
      this.searchParams.pageIndex = val;
      this.getList();
    },
    // 打开提交审核
    openSubmit (obj) {
      console.log(obj);
      this.ids = obj.id;
      this.dialog.submit.show = true;
    },
    // 复制url
    copyUrl (item) {
      let ceshiurl;
      if (window.location.hostname === 'crm.yotur.cn') {
        ceshiurl = 'https://www.youtoo365.com' + '/webApp/vip/activity/' + item.id;
      } else {
        ceshiurl = 'http://218.29.121.74:8081' + '/webApp/vip/activity/' + item.id;
      }
      let doc = document.getElementById('inputValue');
      doc.value = ceshiurl;
      doc.select();
      document.execCommand('Copy');
      this.$message.success('复制成功');
    }
  }
};
</script>
<style lang="scss">
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
</style>



// WEBPACK FOOTER //
// src/components/serveRecd/activityRecd.vue